// extracted by mini-css-extract-plugin
export default {"resetButton":"ForgotPassword_resetButton__Oonaq","backToLoginLink":"ForgotPassword_backToLoginLink__Pr+PN"};